export const generateTagsKeyDownHandler =
  ({ tags, setTags }) =>
  (event) => {
    const CONTROL_KEYS = new Set(['Enter', ',', 'Tab']);
    const { key, target } = event;

    if (key === 'Backspace' && target.value === '') {
      setTags(tags.slice(0, -1));
    }
    if (
      CONTROL_KEYS.has(key) &&
      target.value !== '' &&
      tags.every((tag) => tag !== target.value)
    ) {
      event.preventDefault();
      setTags([...tags, target.value]);
      target.value = '';
    }
  };
